<script>
import Layout from "@/views/layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import ResponsablePagination from "@/components/standard/ResponsibleSGSST/components/ResponsiblePagination";
import sg_sstAPI from "@/services/sg-sst/sg_sstAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";

export default {
  page: {
    title: "Responsable del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    ResponsablePagination,
  },
  data() {
    return {
      title: "1.1.1 Responsable del SG SST",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Responsable del SG SST",
          active: true,
        },
      ],

      submitted: false,
      role: 2,
      itemData: null,
      item1: null,
      itemStatus1: "No cumplido",
      item11: null,
      itemStatus11: null,

      sg_sstData: {
        id: null,
        id_diseno_sso: null,
        employee: null,
        appointment_date: null,
        withdrawal_date: null,
        status: false,
        company_name: null,
        course_start_date: null,
        certificate: null,
      },

      userSelected: null,
      usersList: [],
      responsible: [],
      itemData: null,
      search: "",
      list: [],
      company: "",
      employeeDesignSST: "",
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      company: this.$store.getters["company/getCompany"] || null,
      user: this.$store.state.auth || null,

      loading: true,
      loading2: true,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(1)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      sg_sstAPI.getSGSSTbyCompany(this.$store.getters["company/getCompany"].id, '')
        .then((response) => {
          this.responsible = response;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     */
    sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        company.id_diseno_sso,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    goBack() {
      this.$router.go(-1);
    },

    fetch() {
      this.$refs.paginator.query();
      this.loading = true;
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getStatus(status, date) {
      if (status && date) {
        return isActive(status, date) ? 1 : 0;
      } else {
        return 1;
      }
    },

    goPage(url) {
      window.location.href = url;
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 1)
        .then((response) => {
          this.item1 = response || null;
          this.itemStatus1 = response.status !== undefined ? response.status : this.itemStatus1;
        })
        .catch((error) => {
          console.log(error);
        });

      CompanyItemsAPI.getStatus(this.companyID, 11)
        .then((response) => {
          this.item11 = response || null;
          this.itemStatus11 = response.status;
        })
        .catch((error) => {
          console.log(error);
        });

      this.loading2 = false;
    },

    changeItemStatus(itemStatus1) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 1,
        status: itemStatus1,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          // aprobar item 1.2.3 al aprobar e. 1.1.1
          const itemChangeCourse = {
            companies_id: this.companyID,
            item_id: 11,
            status: itemStatus1,
          }
          newScoresAPI.calculateScores(itemChangeCourse)
            .then(response => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha cambiado el estado del ítem con éxito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              setTimeout(() => window.location.reload(), 2000)
            })
            .catch(error => {
              Swal.fire({
                title: "¡Error!",
                text: "¡No se ha actualizado el estado del ítem!",
                type: "error",
                icon: "error",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              setTimeout(() => window.location.reload(), 2000)
            })
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },
  },

  mounted() {
    this.getItems();
    this.getItemData();
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">

        <div v-if="!loading2">
          <div class="card">

            <div class="card-body">
              <div class="row">

                <div class="col-md-6 col-sm-12 pl-4">

                  <CheckModal>
                    <p class="text-justify">
                      Como responsable del SG-SST van a existir dos roles:
                    </p>
                    <p class="text-justify">
                      <b>Profesional Responsable del SG-SST:</b> Se nombrará por parte de Emisión, será el encargado de guiar todo el
                      proceso de diseño de la implementación de SG-SST.
                    </p>
                    <p class="text-justify">
                      <b>Responsable operativo del SG-SST:</b> Persona por parte de la Empresa que será la encargada de
                      llevar
                      a
                      cabo las actividades correspondientes, recopilar las evidencias y alimentar el sistema con estos
                      archivos para poder hacer seguimiento a las actividades de implementación por parte del
                      Profesional Responsable del SG-SST.
                    </p>
                    <hr />
                    <p class="text-justify">
                      <b>Funciones:</b>
                    </p>
                    <p class="text-justify">
                    <ol>
                      <li>
                        Planificar, dirigir, ejecutar y aplicar el SG-SST.
                      </li>
                      <li>
                        Informar a la gerencia sobre el funcionamiento y resultados del SG-SST.
                      </li>
                      <li>
                        Promover la participación de los miembros de la empresa en la implementación del SG-SST.
                      </li>
                      <li>
                        Promover la comprensión de la política en todas las áreas de la empresa.
                      </li>
                      <li>
                        Coordinar las capacitaciones necesarias en materia de prevención.
                      </li>
                      <li>
                        Apoyar la investigación de accidentes de trabajo.
                      </li>
                      <li>
                        Apoyar las reuniones de los diferentes comités conformados.
                      </li>
                      <li>
                        Implementación, seguimiento y control del SG-SST.
                      </li>
                    </ol>
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus1)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item1 || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus1">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="card-body">

                    <div class="row" v-if="getRole('Crear', [1, 4])">
                      <div class="col-12 text-right">
                        <button type="button" :disabled="!getRole('Crear', [1, 4]) || !allowAccess()"
                          class="btn btn-primary" @click="goPage(`/forms/responsable-sg/add`)">
                          Agregar
                        </button>
                      </div>
                    </div>

                    <div class="row" v-if="!loading && getRole('Consultar')">

                      <div class="row pb-3">
                        <div class="col-6 ml-3">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">

                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>
                      <div class="col-12">


                        <table
                          class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
                          <thead class="table-active">
                            <tr>
                              <th scope="col"
                                class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1">
                                ID
                              </th>
                              <th scope="col"
                                class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
                                Fecha de nombramiento
                              </th>
                              <th scope="col"
                                class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
                                Fecha de retiro
                              </th>
                              <th scope="col"
                                class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
                                Nombre
                              </th>
                              <th scope="col"
                                class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1">
                                Estado
                              </th>
                              <th scope="col"
                                class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1">
                                Actas
                              </th>
                              <th scope="col"
                                class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
                                Acciones
                              </th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="item in responsible" :key="item.id">
                              <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                                <b>{{ item.id }}</b>
                              </td>
                              <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-left">
                                {{ dateConvert(item.appointment_date) }}
                              </td>
                              <td
                                :class="`px-6 text-sm text-gray-500 mx-2 align-middle ${item.withdrawal_date ? 'text-left' : 'text-center'}`">
                                {{ dateConvert(item.withdrawal_date) }}
                              </td>
                              <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-left">
                                {{ item.employee_name }}
                              </td>
                              <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                                <span class="badge float" :class="{
                                  'badge-soft-warning': getStatus(item.withdrawal_date) == 2,
                                  'badge-soft-danger': getStatus(item.withdrawal_date) == 0,
                                  'badge-soft-success': getStatus(item.withdrawal_date) == 1,
                                }">
                                  {{ getStatus(item.withdrawal_date) == 1 ? "Activo" : "Inactivo" }}
                                </span>
                              </td>
                              <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                                <span class="badge mb-1"
                                  :class="item.responsable_status === 'signed' ? 'badge-soft-success' : 'badge-soft-secondary'"
                                  title="Acta Responsable SG-SST">
                                  Resp: {{ item.responsable_status === 'signed' ? 'Firmada' : 'Borrador' }}
                                </span>
                                <br />
                                <span class="badge"
                                  :class="item.operativo_status === 'signed' ? 'badge-soft-success' : 'badge-soft-secondary'"
                                  title="Acta Responsable Operativo">
                                  Oper: {{ item.operativo_status === 'signed' ? 'Firmada' : 'Borrador' }}
                                </span>
                              </td>
                              <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                                <div class="col-sm-12">
                                  <b-dropdown variant="primary"
                                    :disabled="(!getRole('Editar', [1, 4]) && !getRole('Consultar', [1, 2, 3, 4, 5])) || !allowAccess()">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item v-if="getRole('Editar', [1, 4]) || getRole('Consultar', [1, 2, 3, 4, 5])
                                    " :disabled="(!getRole('Editar', [1, 4]) && !getRole('Consultar', [1, 2, 3, 4, 5])) || !allowAccess()"
                                      :to="{ path: `/forms/responsable-sg/${item.id}` }">
                                      {{ getRole("Editar", [1, 4]) ? "Editar" : "Consultar" }}
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="getRole('Consultar', [1, 2, 3, 4, 5]) && item.certificate"
                                      :disabled="!item.certificate || !allowAccess()"
                                      @click="gotoDigitalOcean(item.certificate)">
                                      Descargar certificado
                                    </b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <div>
                          <ResponsablePagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
                            @fetch="(items) => (responsible = items)" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <!-- end col -->
              </div>
            </div>
          </div>

        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>